import { UICommandInterface, UICommandSettingsManagerInterface } from '@nts/std/interfaces';
import { MessageResourceManager } from '../../resources/message-resource-manager';

export class RelatedUICommandSettingsManager implements UICommandSettingsManagerInterface {

    setUICommand(en: string, ui: UICommandInterface): UICommandInterface {

        ui.displayName = MessageResourceManager.Current.getMessage('CMD_' + en);
        ui.name = en;
        ui.tooltip = ui.displayName;
        return ui;
    }
}
